import {DialogActions, DialogContent, Typography} from '@mui/material';
import PropTypes from 'prop-types';

import BoldText from '../../../../form/BoldText';
import Button from '../../../../form/buttons/Button/Button';
import BaseModal from '../../../../modal/BaseModal';

const DeletePractitionerConfirmModal = ({isOpen, onCancel, onSubmit, practitioner}) => {
  return (
    <BaseModal onClose={onCancel} title="Supprimer un praticien" open={isOpen}>
      <DialogContent sx={{p: 3}}>
        <Typography>
          Vous êtes sur le point de supprimer ce praticien :{' '}
          <BoldText>
            {practitioner.first_name?.substring(0, 1)}. {practitioner.last_name}
          </BoldText>
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" color="error" onClick={onCancel}>
          Annuler
        </Button>
        <Button variant="contained" color="error" onClick={onSubmit}>
          Supprimer l'utilisateur
        </Button>
      </DialogActions>
    </BaseModal>
  );
};

DeletePractitionerConfirmModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  practitioner: PropTypes.object.isRequired
};

export default DeletePractitionerConfirmModal;
